import { useEffect, useState } from "react";
import { Capacitor } from "@capacitor/core";

const noop = () => {};

// Returns current keyboard inset in px.
export function useKeyboardInsets(): number {
  const [inset, setInset] = useState(0);

  useEffect(() => {
    let cleanupCap = noop;
    let cleanupVv = noop;

    if (Capacitor.isNativePlatform()) {
      // @vite-ignore prevents Vite from trying to prebundle/resolve when the plugin isn't installed for web dev
      import(/* @vite-ignore */ "@capacitor/keyboard")
        .then((mod) => {
          const Keyboard = (mod as any)?.Keyboard;
          if (!Keyboard || typeof Keyboard.addListener !== "function") return;
          const showSub = Keyboard.addListener("keyboardWillShow", (info: any) => {
            const h = Math.max(info?.keyboardHeight || 0, 0);
            setInset(h);
          });
          const hideSub = Keyboard.addListener("keyboardWillHide", () => {
            setInset(0);
          });
          cleanupCap = () => {
            try { showSub.remove(); hideSub.remove(); } catch {}
          };
        })
        .catch(noop);
      return () => {
        cleanupCap();
      };
    }

    // Web: use visualViewport shrink to infer keyboard height.
    try {
      const vv = window.visualViewport;
      if (vv) {
        const apply = () => {
          const delta = Math.max(0, window.innerHeight - vv.height);
          setInset(delta);
        };
        apply();
        vv.addEventListener("resize", apply, { passive: true });
        cleanupVv = () => {
          vv.removeEventListener("resize", apply);
        };
      }
    } catch {}

    return () => {
      cleanupVv();
    };
  }, []);

  return inset;
}
